import { appModulesG4Tr } from './golf4App.tr.js';
// Turks (tr-TR), modulesApp: zelfde vorm als modulesApp.nl.ts. Wat ontbreekt valt terug op het
// Nederlands (nooit een rauwe sleutel op het scherm).
export const appModulesTr = {
    ...appModulesG4Tr,
    title: 'Modüller',
    intro: 'Ailenin hangi bölümleri kullanacağını seç. Kapatmak hiçbir şeyi silmez: yeniden açarsan her şey yerinde durur.',
    settingsBody: 'Götürme ve alma gibi bölümleri aç ya da kapat',
    on: 'Açık',
    off: 'Kapalı',
    dependsOn: 'Sadece {names} açıksa çalışır.',
    offBecause: 'Kapalı ({names} kapalı)',
    exampleA: 'Elif',
    exampleB: 'Emre',
    holidaysIslamic: 'Ailenin geleneğine göre Ramazan Bayramı ve Kurban Bayramı da.',
    blockedBy: '{names} kapalı olduğu için kapalı.',
    alsoOff: 'Bununla birlikte şunlar da kapanır: {names}.',
    notInPlan: 'Aboneliğinde yok.',
    settings: 'Ayarlar',
    /** WP3: toegankelijke naam van het tandwiel bij een module. */
    settingsOf: '{name} ayarları',
    // Golf 6b (0043): modules die niet bij de soort huishouden passen, en de soort zelf.
    showAll: 'Tüm modülleri göster',
    showFewer: 'Sadece bize uyanlar',
    hiddenNote: 'Hane türünüze uymayan bölümler gizlidir.',
    typeLine: 'Hane türü: {name}',
    typeChange: 'Değiştir',
    toastOn: '{name} açık',
    toastOff: '{name} kapalı. Hiçbir şey silinmedi.',
    toastOption: 'Kaydedildi',
    optionNeeds: '{name} açıksa çalışır.',
    onlyParents: 'Bunu sadece bir ebeveyn değiştirebilir.',
    kioskNote: 'Tablet birkaç saniye içinde kendini günceller.',
    groups: {
        agenda: 'Ajanda ve yolda',
        home: 'Evde ve birlikte',
        personal: 'Kişisel',
        faith: 'İnanç ve gelenek',
        board: 'Pano ve uygulama',
        care: 'Bakım ve aile',
    },
    groupCount: '{total} modülden {on} açık',
    search: 'Modül ara',
    searchNone: '"{q}" için modül bulunamadı.',
    options: 'Seçenekler ({n})',
    offTitle: '{name} kapalı',
    offBody: 'Bu bölüm ailen için kapalı. Hiçbir şey silinmedi.',
    offBodyChild: 'Bu bölüm kapalı. Açması için annene ya da babana sor.',
    offAction: 'Modüllere git',
    rides: {
        dropoff: '{name} götürüyor',
        pickup: '{name} alıyor',
        both: '{name} götürüp alıyor',
        whoDropoff: 'Kim götürecek?',
        whoPickup: 'Kim alacak?',
        travel: '{minutes} dk yolda',
        travelWho: 'Sürücü {name} · {minutes} dk',
        /** 0056: smal blokje ná de afspraak (de weg terug). */
        travelBack: '{minutes} dk dönüş',
    },
};
//# sourceMappingURL=modulesApp.tr.js.map